import { clearFeatures, disableFeature, enableFeature, resetFeature } from 'Cloud/Application/FeaturesEs6';
import config from 'Cloud/config';

const FEATURES = config.get('FEATURES');

export function manageFeatures(featuresNamesToValues: Record<string, any>, mode: string | number = 1) {
    if (mode === 'check' || mode === 0) {
        return Object.keys(featuresNamesToValues).reduce((acc, ftr) => {
            acc[ftr] = { enabled: FEATURES.enabled.includes(ftr), config: FEATURES.configs[ftr] };
            return acc;
        }, {});
    }

    let effect: (...args) => void = () => {};
    switch (mode) {
        case 'enable':
        case 1:
            effect = enableFeature;
            break;
        case 'disable':
        case 2:
            effect = disableFeature;
            break;
        case 'reset':
        case 3:
            effect = resetFeature;
            break;
        case 'reset-all':
        case 4:
            clearFeatures();
            effect = enableFeature;
            break;
    }
    Object.entries(featuresNamesToValues).forEach(([name, value]) => {
        effect(name, value);
    });
}
